<script>
import ButtonBreadcrumbs from '@components/breadcrumbs/button-breadcrumbs.vue';
import { programComputed, workoutComputed, workoutMethods } from '@/src/state/helpers';

export default {
  components: {
    ButtonBreadcrumbs,
  },
  props: {
    workout: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    ...programComputed,
    ...workoutComputed,
    prevPageName() {
      return this.$route.params.prevRoute === 'home' ? 'Home' : 'Workout Preview';
    },
  },
  mounted() {},
  methods: {
    ...workoutMethods,
    backToPreviousPage() {
      this.$route.params.prevRoute === 'workoutDetail'
        ? this.$router.push({
            name: 'workoutDetail',
            params: {
              id: this.selectedWorkout.programDayWorkout.programWorkout_id,
              workoutOption: { programDay_id: this.workout.programDayId, ...this.workoutDetails },
            },
          })
        : this.$router.push({ name: 'home' });
    },
  },
};
</script>

<template>
  <div class="exercise-video-header">
    <ButtonBreadcrumbs :prevPageName="prevPageName" @to-route="backToPreviousPage" />
    <div class="exercise-title">{{ currentExercise.label }}</div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.exercise-video-header {
  align-items: center;
  display: none;
  justify-content: center;
  margin-top: 3rem;

  @include media('xxl', null) {
    display: flex;
  }

  .btn-breadcrumbs {
    display: none;

    @include media('xxl', null) {
      display: block;
    }
  }

  .exercise-title {
    @include calc-font-size(1.3);

    background-color: white;
    border-radius: $base-border-radius-lg + 2;
    color: #333;
    font-weight: bold;
    line-height: 2.6rem;
    padding: 1rem 2.3vw;
    text-align: center;
    text-transform: capitalize;
    width: fit-content;
  }
}
</style>
